import { reactPlugin } from "./app-insights";
import { BrowserRouter } from "react-router-dom";
import ExampleMiddleware from "./middlewares/example-middleware";
import { AppRoutes } from "./routes";

import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

function App() {
    return (
        <AppInsightsErrorBoundary onError={() => <h1>An error occurred!</h1>} appInsights={reactPlugin}>
            <ExampleMiddleware>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </ExampleMiddleware>
        </AppInsightsErrorBoundary>
    );
}

export default App;
